import React, {Component} from 'react';

class Coba extends Component {
  render(){
    return(
      <div>
         <div>Coba</div>
      <div>Coba</div>
      <div>Coba</div>
      <div>Coba</div>
      <div>Coba</div>
      <div>Coba</div>
      <div>Coba</div>
      </div>
     
    )
  }
}


export default Coba;